<div class="content">
    <img src="../../../../../assets/images/not-found-image.png">
    <div class="caption">404</div>
    <div class="description">Ups page not found!</div>
</div>